
import './App.css';

import React, { Component } from 'react'
import Kas from './components/Kas';
import News from './components/News';

export default class App extends Component {
   c='john';
  render() {
    return (
      <div>
        {/* <Kas></Kas> */}
<News></News>
      </div>
    )
  }
}
// 62a3fcd0c0f5405e84e3e9ccd671045a




